var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToolLayout"},[_c('tool-header',{attrs:{"name":_vm.name}}),_c('section',{staticClass:"ToolLayout__tool"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }